import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react';
import LatestPosts from './LatestPosts';

interface Props {
  title?: string;
  className?: string;
}

export default function LatestPostsStandalone({ title = undefined, className = '' }: Props) {
  const data = useStaticQuery<Queries.LatestPostsStandaloneQuery>(graphql`
    query LatestPostsStandalone {
      allWpPost(sort: { date: DESC }, limit: 12) {
        nodes {
          ...PostCardData
        }
        totalCount
      }
    }
  `);

  return (
    <LatestPosts
      title={title}
      posts={data.allWpPost.nodes}
      className={className}
      totalCount={data.allWpPost.totalCount}
    />
  );
}
